import React, { useEffect, useMemo, useState } from "react";
import { Card, Image, Text } from "@fluentui/react-components";
import { makeStyles } from "@fluentui/react-components";
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux';
import Amenities from "./Amenities";
import Stack from "./Stack";
import Status from "./Status";
import { getLocalitation } from "../common/utilities/utilities";
import { useTranslation } from "react-i18next";
import { api } from "../api/api";
import { NOT_AVAILABLE } from "../variables";

import {
  setLoading,
  defaultSuccess,
  defaultCatch,
} from '../redux/actions';

const useStyles = makeStyles({
  body: {
    color: '#616161 !important',
  },
  times: {
    color: '#5B5FC7 !important',
  }
})

function Room(props) {
  const {
    setLoading,
    defaultSuccess,
    defaultCatch,
    room = {},
    onSelectsRoom = () => { },
    selectedRoom = {},
    startTime,
    endTime,
  } = props;

  const styles = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);
  const [roomImage, setRoomImage] = useState()
  const [status, setStatus] = useState({ message: t('Not Available'), className: NOT_AVAILABLE })

  const fetchRoomImage = () => {
    const image = room?.photos[room?.photos?.length - 1]?.url.replace(/^\/api/, '')
    if (!image) return setRoomImage()

    setLoading(true)
    api.get(image, { responseType: "blob" })
      .then(defaultSuccess)
      .then(({ data }) => setRoomImage(URL.createObjectURL(data)))
      .catch(error => defaultCatch(error, history, () => fetchRoomImage()))
  }

  useEffect(() => {
     fetchRoomImage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getBorder = useMemo(() => {
    if (selectedRoom?.id === room.id) return '2px solid #5B5FC7'
    return '1px solid #E1E1E1'
  }, [selectedRoom, room])

  const onClick = () => {
    if (status.className === NOT_AVAILABLE) return
    onSelectsRoom(room)
  }

  return (
    <Card style={{ border: getBorder }} onClick={onClick} >
      <Stack direction="column" gap="8px">
        <Stack direction="row" gap="8px">
          <Stack direction="column" gap="8px" flexWrap="wrap" style={{ flex: 1, minWidth: 0 }}>
            <Text size={200} weight="bold" >{room.name}</Text>
            <Text className={styles.body} size={200}>{`${t('Location')}: ${getLocalitation(room)}`}</Text>
            <Text className={styles.body} size={200}>{t('capacity')}: {room?.capacity} {t('seats')}</Text>
            {roomImage && room.amenities?.length > 0 &&
              <Amenities
                showAll={showAll}
                setShowAll={setShowAll}
                amenities={room.amenities}
              />
            }
          </Stack>
          <Stack direction="column" gap="10px" flexWrap="wrap" alignItems="end">
            <Status
              room={room}
              startTime={startTime}
              endTime={endTime}
              setStatus={setStatus}
            />
            {roomImage &&
              <Image
                shape="rounded"
                width={160}
                alt={t("Room photo")}
                src={roomImage}
              />
            }
          </Stack>
        </Stack>
        {!roomImage && room.amenities?.length > 0 &&
          <Amenities
            showAll={showAll}
            setShowAll={setShowAll}
            amenities={room.amenities}
          />
        }
      </Stack>
    </Card>
  )
}


const mapDispatchToProps = {
  setLoading,
  defaultSuccess,
  defaultCatch
}

export default connect(null, mapDispatchToProps)(Room)